<template>
  <el-dialog
    title="文件重命名"
    :visible.sync="visible"
    width="563px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="54px"
      :rules="rules"
      class="name-ruleForm"
    >
      <el-form-item label="名称：" prop="name">
        <el-input
          placeholder="请输入文件名称"
          v-model.trim="ruleForm.name"
          maxlength="20"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { renameFolderFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请填写文件名称", trigger: "blur" }],
      },

      folderId: null,
    };
  },

  methods: {
    handleClose() {
      this.visible = false;
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          renameFolderFetch({
            folderId: this.folderId,
            name: this.ruleForm.name,
          }).then((res) => {
            if (res.code == "0000") {
              this.$message.success("重命名成功");
              this.resetForm(formName);
              this.$emit("updateFolder");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.name = "";
      this.handleClose();
    },
    showModal(node) {
      this.visible = true;
      this.ruleForm.name = node.data.name;
      this.folderId = node.data.id;
    },
  },
};
</script>

<style lang="less"  >
.name-ruleForm {
  .el-form-item {
    margin-bottom: 0 !important;
  }
}
</style>